import React from "react";
import TypeWriter from "react-typewriter";
import ScrollAnimation from "react-animate-on-scroll";

const Header = ({ data }) => {
  if (data) {
    var name = data.name;
    var occupation = data.occupation;
    var description = data.description;
    var street = data.address.street;
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }
  return (
    <header id="home">
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>

        <ul id="nav" className="nav animate__animated animate__fadeInDown">
          <li className="current">
            <a className="smoothscroll" href="#home">
              Home
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#about">
              About
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#resume">
              Resume
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#portfolio">
              Works
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#testimonials">
              Testimonials
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#contact">
              Contact
            </a>
          </li>
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">
            <ScrollAnimation animateIn="animate__fadeInDown" animateOut="animate__fadeOutDown">
              <TypeWriter typing={0.6}>{name ? `I'm ${name}.` : null}</TypeWriter>
            </ScrollAnimation>
          </h1>
          <ScrollAnimation
            animateIn="animate__fadeInDown"
            animateOut="animate__fadeOutDown"
            delay="300"
          >
            {/* <h3 className="banner-info animate__animated animate__bounceIn">
              Based in {city}. <span>{occupation}</span>. {description}.
            </h3> */}
            <h3 className="banner-info animate__animated animate__bounceIn">
              Based in {street}. <span>{occupation}</span>. {description}.
            </h3>
            <div style={{ backgroundColor: "#a8a8a8", color: "lightgray" }}>
              <hr
                style={{
                  backgroundImage: "linear-gradient(90deg,transparent,rgba(0,0,0,.75),transparent)",
                  border: "0",
                  height: "1px",
                }}
              />
            </div>

            <ul className="social animate__animated animate__flipInX">{networks}</ul>
          </ScrollAnimation>
        </div>
      </div>

      <p className="scrolldown banner-info animate__animated animate__bounceIn animate__delay-4s">
        <a className="smoothscroll" href="#about">
          <img src="/images/scroll-down.gif" alt="" />
          {/* <i className="icon-down-circle"></i> */}
        </a>
      </p>
    </header>
  );
};

export default Header;
